import * as React from 'react';
import { Modal, Button } from 'antd';
import { tokens } from 'src/design-system';

export default class InquiryDuplicateModal extends React.PureComponent<any, any> {
  render() {
    const { visible, handleOk, handleCancel } = this.props;
    return (
      <Modal
        title="Create Duplicate Inquiry"
        visible={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            No
          </Button>,
          <Button key="submit" type="primary" onClick={handleOk}
           style={{ background: tokens.colors.primary, border: tokens.colors.primary }}>
            Yes
          </Button>,
        ]}
        >
        <p>Are you sure, you want to Create Duplicate?</p>
      </Modal>
    );
  }
}
